import React from 'react'
import {
  CalloutCon,
  CalloutInfoCol,
  CalloutActionCol,
  CalloutLink,
  CalloutInner,
} from './styles'
import { Img } from '../Image/Img'

type AnnouncementCalloutParams = {
  title: string
  buttonText: string
  buttonLink: string
  description?: string
  image?: string
  leftBorderColor?: string
  border?: boolean
}

export const AnnouncementCallout: React.FC<
  React.PropsWithChildren<AnnouncementCalloutParams>
> = ({
  title,
  description,
  buttonText,
  buttonLink,
  image,
  leftBorderColor,
  border = false,
}) => {
  return (
    <CalloutCon leftBorderColor={leftBorderColor} border={border}>
      <div className="callout">
        <div className="calloutOptionRow">
          <CalloutInner>
            {image && <Img src={image} alt="" />}
            <CalloutInfoCol>
              <div className="title">{title}</div>
              {description && <div className="description">{description}</div>}
            </CalloutInfoCol>
          </CalloutInner>
          <CalloutActionCol>
            <CalloutLink href={buttonLink} aria-label={buttonText}>{buttonText}</CalloutLink>
          </CalloutActionCol>
        </div>
      </div>
    </CalloutCon>
  )
}
